/**
 * ISO / TENANT INFORMATIONS /
 * In Voyager-script/scripts/_common/utils.js
 */

export const TENANTS = {
  SAMSUNG_FR: "samsung_fr",
  SAMSUNG_BE: "samsung_be",
  SAMSUNG_NL: "samsung_nl",
  SAMSUNG_ES: "samsung_es",
  SAMSUNG_ES_APZ: "samsung_es_apz",
  SAMSUNG_PT: "samsung_pt",
  SAMSUNG_IT: "samsung_it",
  RUE_DU_COMMERCE: "rue_du_commerce",
  UZIT: "uzit",
  MICROMANIA: "micromania",
  MICROMANIA_WEB: "micromania_web",
  CULTURE_VELO: "culture_velo",
  RETAIL_BPLS: "retail_bpls",
  MORTAR: "mortar",
  BUT: "but",
  BOUTICYCLE: "bouticycle",
  VELO_STATION: "velo_station",
  BPLS: "bpls",
  CONFORAMA: "conforama",
  CONFORAMA_RETAIL: "conforama_retail",
  RETAIL_IT: "retail_it",
  RETAIL_FNAC_PT: "retail_fnac_pt",
  FOCAL: "focal",
  PROXY_CYCLE: "proxy_cycle",
  SENSO_IT: "senso_it",
  MYPANGEE_CANYON: "mypangee_canyon",
  EVOLLIS_VELO: "evollis_velo",
  PROXY_CYCLE_EVO: "proxy_cycle_evo",
  UZIT_EVOLLIS: "uzit_evollis",
  MICROMANIA_EVOLLIS: "micromania_evollis",
  MEDIAMARKT_NL: "mediamarkt_nl",
  MEDIAMARKT_BE: "mediamarkt_be"
}

export const STEPS = {
  LOGIN: "login",
  HOME: "stepHome",
  CB: "stepCB",
  CB_KO: "cbKo",
  SERVICES: "stepServices",
  ORDER: "stepOrder",
  IDENTIFICATION: "stepIdentification",
  ONBOARDING: "stepOnboarding",
  CLIENT: "stepClient",
  SUMMARY: "stepSummary",
  APZ_CHECKOUT: "stepApzCheckout",
  NETHEOS: "stepNetheos",
  ACCEPTANCE: "stepAcceptance",
  ADYEN_PAYMENT_VALIDATION: "stepAdyenPaymentValidation",
  FINAL: "stepFinal",
  SCORE_KO: "scoreKo",
  ALGOAN: "stepAlgoan",
  ALGOAN_BACK: "stepAlgoanBack"
}

export const FINANCERS = {
  PFLOC: "PFLOC",
  PDI: "PDI",
  PERSONAL_RENTING: "PERSONAL_RENTING",
  EVOLLIS: "EVOLLISFINANCE"
}

export const COUNTRY_CODES = {
  FR_BE: "fr-BE",
  NL_BE: "nl-BE",
  FR_FR: "fr-FR"
}

export const PDI_ROUTES = {
  HOME: "/home",
  SIMULATION: "/simulation",
  RESUME_ORDER: "/resume-order"
}

export const DOCUMENTS_OPTIONS = {
  SAV: "SAV",
  DISTRIBUTOR: "DISTRIBUTOR"
}

export const DOCUMENTS_TYPE = {
  WAY_OUT_DOCUMENT: "WAY_OUT_DOCUMENT",
  DELIVERY_FORM: "DELIVERY_FORM"
}

export const ADYEN_TENANTS = [TENANTS.SAMSUNG_NL, TENANTS.RETAIL_FNAC_PT, TENANTS.MEDIAMARKT_NL]

export const AXEPTA_TENANTS = [TENANTS.SAMSUNG_IT, TENANTS.RETAIL_IT, TENANTS.SENSO_IT]

export const APLAZAME_TENANTS = [TENANTS.SAMSUNG_ES_APZ]

export const PAYLINE_TENANTS = [
  TENANTS.SAMSUNG_FR,
  TENANTS.SAMSUNG_BE,
  TENANTS.SAMSUNG_ES,
  TENANTS.SAMSUNG_PT,
  TENANTS.RUE_DU_COMMERCE,
  TENANTS.UZIT,
  TENANTS.MICROMANIA,
  TENANTS.MICROMANIA_WEB,
  TENANTS.CULTURE_VELO,
  TENANTS.RETAIL_BPLS,
  TENANTS.MORTAR,
  TENANTS.BOUTICYCLE,
  TENANTS.VELO_STATION,
  TENANTS.BPLS,
  TENANTS.CONFORAMA,
  TENANTS.FOCAL,
  TENANTS.PROXY_CYCLE,
  TENANTS.MYPANGEE_CANYON,
  TENANTS.EVOLLIS_VELO,
  TENANTS.PROXY_CYCLE_EVO,
  TENANTS.UZIT_EVOLLIS,
  TENANTS.MICROMANIA_EVOLLIS,
  TENANTS.BUT,
  TENANTS.CONFORAMA_RETAIL,
  TENANTS.MEDIAMARKT_BE
]

export const TENANTS_BY_PAYMENT_PROVIDERS = {
  ADYEN: ADYEN_TENANTS,
  AXEPTA: AXEPTA_TENANTS,
  PAYLINE: PAYLINE_TENANTS,
  APLAZAME: APLAZAME_TENANTS
}
